export default class ConstantService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getConsignmentType() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Consignment/ConsignmentType`);
  }

  getCustomerDocumentType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Customer/CustomerDocumentType`
    );
  }

  getCustomerDocumentStatus() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Customer/CustomerDocumentStatus`
    );
  }

  getCustomerStatusTypes() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Customer/CustomerStatus`);
  }

  getCustomerTypes() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Customer/CustomerType`);
  }

  getCustomerRegionPriceType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Customer/CustomerRegionPriceType`
    );
  }

  getCustomerRegionStatusType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Customer/CustomerRegionPriceStatus`
    );
  }

  getConsignmentProviderPricingType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Consignment/ConsignmentProviderPricingType`
    );
  }

  getConsignmentStatus() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Consignment/ConsignmentStatus?groups=main`
    );
  }

  getOfferStatus() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Offer/OfferStatus`);
  }

  getConsignmentDocumentType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Consignment/ConsignmentDocumentType`
    );
  }

  getConsignmentPostType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Consignment/ConsignmentPostType`
    );
  }

  getConsignmentPackageType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Consignment/ConsignmentPackageType`
    );
  }

  getPackageStatus() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Package/PackageStatus`);
  }

  getAddressType() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Address/AddressType`);
  }

  getCustomerPaymentType() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Customer/CustomerPaymentType`);
  }

  getProviderAdditionalFeeStatus() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Provider/ProviderAdditionalFeeStatus`
    );
  }

  getProviderAdditionalFeePricingType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Provider/ProviderAdditionalFeePricingType`
    );
  }

  getProviderRulePricingType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Provider/ProviderRulePricingType`
    );
  }

  getUserStatus() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/User/UserStatus`);
  }

  getTaxStatus() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Tax/TaxStatus`);
  }

  getTaxApplicationScope() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Tax/TaxApplicationScope`);
  }

  getProviderRegionPricePackageType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Provider/RegionPricePackageType`
    );
  }

  getExportType() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Export/ExportType`);
  }

  getDashboardFilterTransportDirection() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Dashboard/FilterTransportDirection`
    );
  }

  getTransportDirection() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Provider/TransportDirection`);
  }

  getTransportType() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Provider/TransportType`);
  }

  getProviderRuleType() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Provider/ProviderRuleType`);
  }

  getProviderRuleOperator() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Provider/ProviderRuleOperator`
    );
  }

  getProviderPriceImportStatus() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Provider/ProviderPriceImportStatus`
    );
  }

  getProviderDispatchMode() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Provider/ProviderDispatchMode`
    );
  }

  getExportStatus() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Export/ExportStatus`);
  }

  getPickupStatus() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/Pickup/PickupStatus`);
  }

  getPickupConsignmentStatus() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Pickup/PickupConsignmentStatus`
    );
  }

  getCompanyType() {
    return this.axiosIns.get(`${this.serviceConfig.constantEndpoint}/LedgerAccount/CompanyType`);
  }
}
